/* src/app/components/pages/forgot-password/forgot-password.component.scss */
.mat-content {
  display: block;
  position: relative;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  margin: auto;
  padding: 20px 15px 0px 15px;
}
@media screen and (max-width: 599px) {
  .forgotPassword button {
    width: 100%;
    margin-bottom: 10px !important;
  }
}
.forgetPasswordOptions {
  display: flex;
  margin-bottom: 25px;
}
.forgetPasswordOptions .ds-radio {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.forgetPasswordOptions .ds-radio__button {
  top: unset;
}
.forgetPasswordOptions .fieldBox {
  width: 100%;
  margin-bottom: 0;
}
.account_recovery_msg_1 {
  font-size: 15px;
}
.account_recovery_msg_2 {
  font-weight: 700;
}
.container .titleHeader {
  padding: 24px 0px 16px 0px;
}
.container .color-f-s-16 {
  font-size: 16px;
  font-family: "IBM Plex Sans", sans-serif;
  font-style: sans-serif;
  text-align: justify;
}
.container .resetButton .mat-mdc-button {
  color: #ffffff;
  font-size: 14px;
  background-color: #51c1e8;
  margin: 5px 0px 15px 0px;
  padding: 0px 6px;
}
@media only screen and (max-width: 600px) {
  .container .resetButton .mat-mdc-button {
    width: 100%;
    margin-bottom: 10px !important;
  }
}
/*# sourceMappingURL=forgot-password.component.css.map */
